namespace TabAurous.HR {
    export interface AttendanceDetailsForm {
        TransId: Serenity.StringEditor;
        EmployeeId: Serenity.StringEditor;
        TransDate: Serenity.DateEditor;
        Present: Serenity.BooleanEditor;
        Absent: Serenity.BooleanEditor;
        HalfDay: Serenity.BooleanEditor;
        OnLeave: Serenity.BooleanEditor;
    }

    export class AttendanceDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'HR.AttendanceDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AttendanceDetailsForm.init)  {
                AttendanceDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.BooleanEditor;

                Q.initFormType(AttendanceDetailsForm, [
                    'TransId', w0,
                    'EmployeeId', w0,
                    'TransDate', w1,
                    'Present', w2,
                    'Absent', w2,
                    'HalfDay', w2,
                    'OnLeave', w2
                ]);
            }
        }
    }
}
